/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {IconsDecorativeExample, IconsResponsiveExample, IconsSVGExample} from 'Docs/uilib/usage/accessibility/icons/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    strong: "strong",
    a: "a",
    h2: "h2",
    code: "code",
    em: "em"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Accessibility of Icons"
    }), "\n", _jsxs(_components.p, {
      children: ["By using inline SVG, we have the possibility to make graphical assets both ", _jsx(_components.strong, {
        children: "responsive"
      }), " and ", _jsx(_components.strong, {
        children: "interactive"
      }), ". In order to do so, use the ", _jsx(_components.a, {
        href: "/uilib/components/icon",
        children: "Icon"
      }), " or ", _jsx(_components.a, {
        href: "/uilib/components/icon-primary",
        children: "IconPrimary"
      }), " component. These components provide the needed runtime processing."]
    }), "\n", _jsx(_components.h2, {
      children: "Decorative Icons"
    }), "\n", _jsxs(_components.p, {
      children: ["If your icons are purely ", _jsx(_components.strong, {
        children: "decorative"
      }), ", you’ll need to manually add an ", _jsx(_components.strong, {
        children: "aria-hidden"
      }), " (results in ", _jsx(_components.code, {
        children: "aria-hidden={true}"
      }), ") attribute to each of your icons so your app is \"accessible\"."]
    }), "\n", _jsx(IconsDecorativeExample, {}), "\n", _jsx(_components.h2, {
      children: "Responsive Icons"
    }), "\n", _jsxs(_components.p, {
      children: ["Use ", _jsx(_components.code, {
        children: "size=\"auto\""
      }), " to force the icon to inherit the size of its parent element."]
    }), "\n", _jsx(IconsResponsiveExample, {}), "\n", _jsx(_components.h2, {
      children: "SVG Icons"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.em, {
        children: "Scalable Vector Graphics"
      }), " can be set up to be scalable and actually respond to the ", _jsx(_components.code, {
        children: "font-size"
      }), "."]
    }), "\n", _jsx(IconsSVGExample, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
